/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Cabin,
    CabinFromJSON,
    CabinFromJSONTyped,
    CabinToJSON,
} from './';

/**
 * 
 * @export
 * @interface CabinCriteriaRequest
 */
export interface CabinCriteriaRequest {
    /**
     * 
     * @type {Cabin}
     * @memberof CabinCriteriaRequest
     */
    value?: Cabin;
    /**
     * 
     * @type {boolean}
     * @memberof CabinCriteriaRequest
     */
    exclude?: boolean;
}

export function CabinCriteriaRequestFromJSON(json: any): CabinCriteriaRequest {
    return CabinCriteriaRequestFromJSONTyped(json, false);
}

export function CabinCriteriaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CabinCriteriaRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'value': !exists(json, 'value') ? undefined : CabinFromJSON(json['value']),
        'exclude': !exists(json, 'exclude') ? undefined : json['exclude'],
    };
}

export function CabinCriteriaRequestToJSON(value?: CabinCriteriaRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'value': CabinToJSON(value.value),
        'exclude': value.exclude,
    };
}


